// extracted by mini-css-extract-plugin
export default {"price":"p9-z","priceRow":"q9-z","onSale":"r9-z","msrpLabelPrice":"s9-z","msrpLabel":"t9-z","originalPrice":"u9-z","percentOff":"v9-z"};